import gql from 'graphql-tag'

export const CREATE_ANNOUNCEMENT = gql`
  mutation CreateAnnouncement($eventId: ID!, $input: CreateAnnouncementInput!) {
    createAnnouncement(input: $input, eventId: $eventId) {
      id
    }
  }
`
export const DELETE_ANNOUNCEMENT = gql`
  mutation DeleteAnnouncement($eventId: ID!, $id: ID!) {
    deleteAnnouncement(eventId: $eventId, id: $id)
  }
`

export const GET_EVENT_ANNOUNCEMENT = gql`
  query GetAnnouncements($eventId: ID!) {
    getAnnouncements(eventId: $eventId) {
      id
      title
      text
      isPushNotification
      createdAt
    }
  }
`

export const GET_ANNOUNCEMENT = gql`
  query GetAnnouncement($eventId: ID!, $id: ID!){
    getAnnouncement(eventId: $eventId, id: $id){
      id
      title
      text
      isPushNotification
      createdAt
    }
  }
`
